import { convertToOnlineSchedule } from "../../js/localDB"
import { login } from "../../js/script"
import { useNavigate } from "react-router-dom"

function Convert() {
    const navigate = useNavigate();
    return(<div class="modal fade " id="convert" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
    <div class="modal-dialog">
    <div class="modal-content bg-dark">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Login and Upload</h5>
      </div>
      <div class="modal-body">
        <p>Uploading your schedule unlocks Skilldules full potential.</p>
        <button class="btn btn-primary" onClick={() => {
            login().then((auth) => {
            convertToOnlineSchedule(auth).then(() => {
                navigate(0)
            })
            }
            )
        }}>Login</button>
        
        
    
    </div>
    </div>
    </div>
    </div>)
}

export default Convert;